import { bindings } from '@polleverywhere/slideware-bindings'

export default async (app) => {
  const dispatcher = _.clone(Backbone.Events)

  dispatcher.listenTo(app, 'reset:state', async (state) => { // top-level app state has been reset
    const isInsertable = await bindings.slidesInsertable()
    // Set the initial state
    state.appStates.slideware.set('insert', isInsertable)
    // To correctly configure presentation events always
    // reset to set the current state
    bindings.stopListening()
    bindings.on('slidesInsertable', (event) => {
      state.appStates.slideware.set('insert', event.data)
    })

    bindings.on('operationProgress', (event) => {
      state.appStates.slideware.set('operationProgress', event.data)
    })
  })
}
